import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-pro-sidebar/dist/css/styles.css';
import { storeRedux } from 'storeRedux';

// React tooltip
import 'react-tooltip/dist/react-tooltip.css';

import { store, StoreContext } from '@app/stores/store';

// export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL, forceRefresh: true });

// load user if exist
const user = JSON.parse(localStorage.getItem('user'));
if (user) {
	store.userStore.user = user;
}

const igramKarte = JSON.parse(localStorage.getItem('igram'));
if (igramKarte) {
	store.pokerStore.initKarte = igramKarte;
}

const cardDesk = JSON.parse(localStorage.getItem('cardDesk'));
if (cardDesk) {
	store.pokerStore.cardDeskFront = cardDesk;
}

const karteDrugihIgraca = JSON.parse(localStorage.getItem('karteDrugihIgraca'));
if (karteDrugihIgraca) {
	store.pokerStore.karteDrugihIgraca = karteDrugihIgraca;
}

const lokalnaFakeDatoteka = JSON.parse(localStorage.getItem('lokalnaFakeDatoteka'));
if (lokalnaFakeDatoteka) {
	store.pokerStore.lokalnaFakeDatoteka = lokalnaFakeDatoteka;
}

// ako je true uzmiamo test podatke
const fakeData = JSON.parse(localStorage.getItem('fakeData'));
if (fakeData) {
	store.pokerStore.fakeData = fakeData;
	store.pokerStore.valueSlider = 30;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={storeRedux}>
			<StoreContext.Provider value={store}>
				<App />
			</StoreContext.Provider>
		</Provider>
	</React.StrictMode>
);
